import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const rows = [{
  bad: '3-5 hs/semana buscando tips en YouTube',
  good: '10 min/semana revisando tu Dashboard de métricas'
}, {
  bad: 'Siempre los mismos peloteos básicos',
  good: '60+ drills y progresiones técnicas listas'
}, {
  bad: 'Errores no forzados y frustración en el 9-9',
  good: 'Checklist de reparación técnica en tiempo real'
}, {
  bad: 'Gastar miles en gomas que no te sirven',
  good: 'Guía de hardware para comprar lo exacto'
}, {
  bad: 'Cero estructura visible de avance en el club',
  good: 'Sistema directo al próximo nivel en 30 días'
}];
export function ComparisonSection() {
  return <section className="py-10 sm:py-16 lg:py-24 bg-navy-800" data-id="element-56">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        <div className="text-center mb-8 sm:mb-12" data-id="element-58">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-display text-offwhite uppercase mb-3" data-id="element-59">
            LA REALIDAD:{' '}
            <span className="text-gold-500" data-id="element-60">¿Cuánto cuesta NO tenerlo?</span>
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-900 rounded-2xl border border-navy-700 overflow-hidden shadow-2xl" data-id="element-61">
          {/* Header */}
          <div className="grid grid-cols-2 border-b border-navy-700" data-id="element-62">
            <div className="p-3 sm:p-4 md:p-6 text-center bg-navy-900/50" data-id="element-63">
              <h3 className="font-display text-base sm:text-xl md:text-2xl text-text-secondary uppercase tracking-wide" data-id="element-64">
                Sin el sistema
              </h3>
            </div>
            <div className="p-3 sm:p-4 md:p-6 text-center bg-gold-500/10 border-l border-navy-700" data-id="element-65">
              <h3 className="font-display text-base sm:text-xl md:text-2xl text-gold-400 uppercase tracking-wide" data-id="element-66">
                Con el Kit Dominio Total
              </h3>
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-navy-700/50" data-id="element-67">
            {rows.map((row, i) => <motion.div key={i} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="grid grid-cols-2 group hover:bg-navy-800/30 transition-colors" data-id="element-68">
                <div className="p-3 sm:p-4 md:p-6 flex items-start gap-2 sm:gap-3 md:gap-4 bg-navy-900/30 group-hover:bg-transparent transition-colors" data-id="element-69">
                  <XIcon className="w-4 h-4 sm:w-5 sm:h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-70" />
                  <p className="text-xs sm:text-sm md:text-base text-text-secondary leading-snug" data-id="element-71">
                    {row.bad}
                  </p>
                </div>
                <div className="p-3 sm:p-4 md:p-6 flex items-start gap-2 sm:gap-3 md:gap-4 bg-gold-500/5 border-l border-navy-700 group-hover:bg-gold-500/10 transition-colors" data-id="element-72">
                  <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-gold-400 flex-shrink-0 mt-0.5" data-id="element-73" />
                  <p className="text-xs sm:text-sm md:text-base text-offwhite font-medium leading-snug" data-id="element-74">
                    {row.good}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}